DialogTiposOrdenesEditCtrl.$inject = ['$log', '$scope', '$http'];
export default function DialogTiposOrdenesEditCtrl($log, $scope, $http) {
    var URL_BASE = Sigo.var.path + '/mantenimiento' + '/tipos-ordenes';
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: false,
        submit: false
    };

    vm.formDeshabilitado = false;
    vm.modoEdicion = typeof vm.model.tipoOrdenId != 'undefined';

    if (vm.modoEdicion)
        cargarTipoOrden(vm.model.tipoOrdenId);

    function cargarTipoOrden(tipoOrdenId) {
        vm.cargando.datos = true;
        vm.formDeshabilitado = true;
        var url = URL_BASE + '/details/' + tipoOrdenId;
        var promesa = $http.get(url);
        promesa.then(function (data) {
            vm.model.tipoOrden = data.data;
            vm.cargando.datos = false;
            vm.formDeshabilitado = false;
        });
        return promesa;
    }

    function addTipoOrden(tipoOrden) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;
        var url = URL_BASE + '/add';
        var promesa = $http.post(url, tipoOrden);
        promesa.then(function (data) {
            vm.dialogHandler.close(data);
            var texto = Lang.get('ordenes.mensaje_tipoorden_add_ok');
            $.toast({text: texto, icon: 'success', hideAfter: 5000});
        });
        return promesa;
    }

    function editTipoOrden(tipoOrden) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;
        var url = URL_BASE + '/edit/' + tipoOrden.id;
        var promesa = $http.post(url, tipoOrden);
        promesa.then(function (data) {
            vm.dialogHandler.close(data);
            var texto = Lang.get('ordenes.mensaje_tipoorden_edit_ok');
            $.toast({text: texto, icon: 'success', hideAfter: 5000});
        });
        return promesa;
    }

    vm.submitTipoOrden = function (tipoOrden, modoEdicion) {
        return (modoEdicion) ? editTipoOrden(tipoOrden) : addTipoOrden(tipoOrden);
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }
}